
<!-- 面试题库编辑页面 -->
 <template>
  <div>
    <span id="spanData">
      <el-card class="box-card">
        <!-- 设置title -->
        <h1 id="h1">编辑面试题</h1>

        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="题目标题" prop="title">
            <el-input v-model="form.title"></el-input>
          </el-form-item>

          <el-form-item label="题目标签">
            <span>
              <el-tag
                :key="tag"
                v-for="tag in dynamicTags"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)"
              >
                {{ tag }}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="input"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              >
              </el-input>
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput"
                >+ New Tag</el-button
              >
            </span>
          </el-form-item>

          <el-form-item label="可见范围">
            <el-radio-group v-model="form.visibility" @input="changeRadio">
              <el-radio label="public">全部可见</el-radio>
              <el-radio label="private">仅我可见</el-radio>
              <el-radio label="pointsRequired">积分购买</el-radio>
            </el-radio-group>
            <!-- 积分输入框 -->
            <span id="spanNumber">
              <el-input-number
                v-model="form.price"
                :disabled="inputNumberStatu"
                :precision="2"
                :step="0.1"
                :max="10"
                size="mini"
                controls-position="right"
              ></el-input-number>
            </span>
          </el-form-item>

          <!-- 使用wangEditor富文本 -->
          <el-form-item label="内容">
            <div id="editor"></div>
          </el-form-item>

          <el-form-item id="fabuButton">
            <el-button type="primary" @click="commitEdit">修改</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </span>
  </div>
</template>
 

<script>
// 导入wangEditor
import E from "wangeditor";
import hljs from "highlight.js"; //代码高亮
// 导入封装请求方法
import { bankEdit } from "@/api/questionBank/questionBankEdit.js";
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      form: {},

      // 题目标签用到的字段
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      // ----------------------------------------

      // wangEditor用到的数据
      editor: null,

      // 设置校验规则
      rules: {
        title: [
          { required: true, message: "请输入文章标题", trigger: "blur" },
          { min: 3, max: 100, message: "长度在 3 到 100 个字符", trigger: "blur" },
        ],
      },
      // 积分输入框是否禁用
      inputNumberStatu: true,
      // 积分值
      price: 0,

      // 封装编辑提交的数据
      editData:{},

      // 当前登录用户名称
      userName:""
    };
  },

  // 计算属性
  computed: {
    ...mapState(["questionBankData"]),
  },

  created() {
    // 调用方法进行赋值
    this.getUserName();
    // 初始化wangEditor编辑器配置和数据
    this.handleAdd();

  },

  methods: {
    ...mapMutations(["changeActiveIndex", "getLocalStorageBankEditData"]),

    // 获取当前登录用户
    getUserName() {
      const userData = JSON.parse(localStorage.getItem("accessUserData"));
      this.userName = userData.data.userName;
    },

    // 编辑内容修改提交
    async commitEdit(){

      // 设置编辑提交数据
      this.editData.title=this.form.title;
      this.editData.dynamicTags=this.dynamicTags;
      this.editData.visibility=this.form.visibility;
      this.editData.content=this.editor.txt.html();
      this.editData.price=this.form.price;
      this.editData.bankId=this.form.bankId;

      // 调用封装好的请求方法
      const resData= await bankEdit(this.editData);
      if(resData.status==='200'){
        // 修改成功，进行提示
        this.$message({
          showClose: true,
          message: resData.message,
          type: 'success'
        });

        // 进行跳转
        this.$router.push(
          '/questionBank'
        )
      }

    },

    // 可见范围单选按钮绑定值改变时执行
    changeRadio() {
      // 进行判断，如果为3，则积分输入框设置为false
      if (this.form.visibility === "pointsRequired") {
        this.inputNumberStatu = false;
      } else {
        this.inputNumberStatu = true;
      }
    },

    // 已进入编辑页面调用
    handleAdd() {
      // 调用方法，对数据恢复到vuex中
      this.getLocalStorageBankEditData();

      // 将值赋值给form
      this.form = this.questionBankData.questionBankEditData;
      this.dynamicTags = this.form.dynamicTagList;
      this.inputNumberStatu=this.form.visibility ==='pointsRequired' ? false : true;
      //   配置富文本编辑器
      this.setRichText();
      
    },

    // 封装富文本方法
    setRichText() {
      // this.$nextTick 确保在数据更新并导致的 DOM 变更完成之后执行某些操作。
      this.$nextTick(() => {
        this.editor = new E(`#editor`);
        // 设置代码高亮
        this.editor.highlight = hljs;
        // 配置图片上传
        // this.editor.config.uploadImgServer ="http://ailibrary.fun:8081/questionBand/uploadEditerArticleImage"; //后台接口
        this.editor.config.uploadImgServer =this.$baseUrl+"/questionBand/uploadEditerArticleImage"; //后台接口
        this.editor.config.uploadFileName = "file"; //接收的名称
        // 配置上传视频
        // this.editor.config.uploadVideoServer ="http://ailibrary.fun:8081/questionBand/uploadEditerArticleVideo";
        this.editor.config.uploadVideoServer =this.$baseUrl+"/questionBand/uploadEditerArticleVideo";
        this.editor.config.uploadVideoName = "file";
        // 配置图片上传额外上传参数
        this.editor.config.uploadImgParams = {
          type: "img",
          userName: this.userName
        };
        // 配置视频上传额外参数
        this.editor.config.uploadVideoParams = {
          type: "video",
          userName: this.userName
        };
        // 配置视频上传的大小
        this.editor.config.uploadVideoMaxSize = 5 * 1024 * 1024 * 1024;

        // 设置参数
        this.editor.create(); // 创建

        // 等待编辑器初始化完成后再设置内容
        this.editor.txt.html(this.form.content);

      });
    },

    // 提交按钮（废弃）
    async onSubmit() {
      // 获取富文本中的内容
      let editor = this.editor.txt.html();
      this.form.content = editor;
      this.form.price = this.price;
      // 获取当前用户id
      const userData = JSON.parse(localStorage.getItem("accessUserData"));
      this.form.userId = userData.data.userId;
      // 获取form表单中的内容
      console.log("获取发布的内容" + JSON.stringify(this.form));
      const res = await questionBandAdd(this.form);
      if (res.status === "200") {
        // 发布成功
        // 进行提示
        this.$message({
          message: res.message,
          type: "success",
        });

        // 页面跳转到面试题库,并修改仓库中导航的选中
        this.changeActiveIndex("2");
        this.$router.push("/questionBank");
      }
    },

    // ----------------------题目标签用到的方法----------
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.input.focus();
      });
    },

    // 失去焦点触发
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
        // 设置到form中
        this.form.dynamicTags = this.dynamicTags;
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    // --------------------题目标签用到方法结束-------------
  },
};
</script>
<style scoped>
/* 积分输入框样式 */
#spanNumber {
  margin-left: 10px;
}

/* 外围card样式 */
.box-card {
  width: 70%;
}

/* 外围span标签样式 */
#spanData {
  display: flex;
  justify-content: center;
}

/* 发布文章标题 */
#h1 {
  text-align: center;
}

/* 题目标签样式 */
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
/* ----------------------- */

/* 发布按钮样式 */
#fabuButton {
  text-align: center;
}
</style>